import { Home } from "lucide-react";

export const NAV_ITEMS = [
  { key: "home", to: "/", label: "Home", icon: Home },
];
